import { BrickInventoryEntry } from "../../../BrickInventory/BrickInventory";
import { ActionEntry } from "../../ActionEntries";

export const lacksCapacity = (
  action: ActionEntry,
  newBricks: Map<string, BrickInventoryEntry>,
) => {
  // Validate if costs for action can be met
  for (let i = 0; i < action.outcome.length; i++) {
    const currBrick = newBricks.get(action.outcome[i].brickId);

    // Ignore Capacity and Auto Collect
    if (
      !currBrick ||
      Number.isNaN(currBrick.amount) ||
      currBrick.amount < currBrick.capacity ||
      action.type === "Capacity" ||
      action.type === "Auto Collect"
    ) {
      return false;
    }
  }

  return true;
};
